export default "__VITE_ASSET__CGgJ27hb__"